import BadgeSquare from '../../badge/badgeSquare';

const formatDate = (d) => {
  if (!d) return '-';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const getReasonBadge = (reason) => {
  if (!reason) return { type: 26, label: 'Validé par IA' };
  const isOk = reason.startsWith('[OK]');
  const isFail = reason.startsWith('[ECHEC]');
  const text = reason.replace(/^\[(OK|ECHEC)\]\s*/, '').split(' - ')[0].trim();
  if (isOk) {
    const label = (!text || text.toLowerCase() === 'validé') ? 'Validé par IA' : text;
    return { type: 26, label };
  }
  if (isFail) return { type: 3, label: text || 'Échec' };
  return { type: 9, label: reason };
};

const ValidatedDocumentCard = ({ name, docType, reason, date, onClick }) => {
  const badge = getReasonBadge(reason);
  return (
    <div
      className="bg-white rounded-md border border-gray-200 hover:bg-gray-50 active:bg-gray-100 cursor-pointer transition-all duration-200 text-left"
      onClick={onClick}
    >
      <div className="p-3 sm:p-4">
        {/* Mobile : 2 lignes empilées */}
        <div className="flex flex-col gap-2 sm:hidden">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-semibold text-gray-900 text-sm truncate min-w-0" title={name}>
              {name}
            </h3>
            <div className="shrink-0">
              <BadgeSquare type={badge.type} bordered size="xs" customLabel={badge.label} />
            </div>
          </div>
          <div className="flex items-center justify-between gap-2">
            <span className="text-xs text-gray-500 truncate min-w-0">{docType}</span>
            <span className="text-xs text-gray-400 tabular-nums whitespace-nowrap shrink-0">{formatDate(date)}</span>
          </div>
        </div>

        {/* Desktop : ligne unique avec colonnes fixes */}
        <div className="hidden sm:flex sm:items-center sm:gap-3">
          <h3
            className="font-semibold text-gray-900 text-base truncate shrink-0 w-[200px] min-w-[200px] text-left"
            title={name}
          >
            {name}
          </h3>
          <span className="text-sm text-gray-600 shrink-0 w-[200px] min-w-[200px] truncate" title={docType}>
            {docType}
          </span>
          <div className="shrink-0">
            <BadgeSquare type={badge.type} bordered size="xs" customLabel={badge.label} />
          </div>
          <span className="text-xs text-gray-400 tabular-nums whitespace-nowrap shrink-0 ml-auto">
            {formatDate(date)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ValidatedDocumentCard;
